/* NYECONOMY v2: stable IDs, migratable saves. */
(function(g){const C={
  "version": 3,
  "key": "nyeconomy-save-v1",
  "cap": 1e+100,
  "maxOwned": 10000,
  "growth": 1.18,
  "offlineCap": 28800,
  "offlineEfficiency": 0.5,
  "prestigeScale": 1000000000,
  "credPerRoot": 10,
  "credBonus": 0.1,
  "marketEvery": 30,
  "marketSpread": 0.03,
  "milestones": [
    10,
    25,
    50,
    100,
    200,
    500,
    1000
  ],
  "businesses": [
    {
      "id": "cds",
      "name": "Burned CDs",
      "tag": "music",
      "cost": 10,
      "revenue": 4,
      "seconds": 4,
      "managerCost": 35,
      "manager": "Dubby Doug",
      "joke": "Can burn a CD. Cannot return a lighter.",
      "stat": "albums",
      "icon": 0,
      "scene": 0
    },
    {
      "id": "shirts",
      "name": "Bootleg Shirts",
      "tag": "underground",
      "cost": 90,
      "revenue": 18,
      "seconds": 6,
      "managerCost": 300,
      "manager": "Size-Medium Steve",
      "joke": "Every shirt is medium. Spiritually.",
      "stat": "merch",
      "icon": 1,
      "scene": 1
    },
    {
      "id": "table",
      "name": "Merch Table",
      "tag": "music",
      "cost": 650,
      "revenue": 90,
      "seconds": 8,
      "managerCost": 2000,
      "manager": "Venmo Vince",
      "joke": "Definitely remembers where the cash box is.",
      "stat": "merch",
      "icon": 2,
      "scene": 1
    },
    {
      "id": "bedroom",
      "name": "Bedroom Studio",
      "tag": "music",
      "cost": 3200,
      "revenue": 400,
      "seconds": 10,
      "managerCost": 9000,
      "manager": "Clip Red",
      "joke": "Has not heard silence since 2006.",
      "stat": "albums",
      "icon": 3,
      "scene": 2
    },
    {
      "id": "shows",
      "name": "Underground Shows",
      "tag": "underground",
      "cost": 15000,
      "revenue": 1600,
      "seconds": 12,
      "managerCost": 42000,
      "manager": "Maybe Mike",
      "joke": "Doors at eight. Probably. Different building.",
      "stat": "shows",
      "icon": 4,
      "scene": 3
    },
    {
      "id": "radio",
      "name": "Pirate Radio",
      "tag": "underground",
      "cost": 35000,
      "revenue": 3700,
      "seconds": 14,
      "managerCost": 80500,
      "manager": "DJ Dead Air",
      "joke": "The aerial is a coat hanger. The signal is a movement.",
      "stat": "streams",
      "scene": 3
    },
    {
      "id": "streams",
      "name": "Streaming Catalog",
      "tag": "music",
      "cost": 75000,
      "revenue": 8500,
      "seconds": 16,
      "managerCost": 200000,
      "manager": "DJ Buffering",
      "joke": "Your biggest fan is a server in a cupboard.",
      "stat": "streams",
      "icon": 5,
      "scene": 3
    },
    {
      "id": "shop",
      "name": "Corner Record Shop",
      "tag": "property",
      "cost": 180000,
      "revenue": 20000,
      "seconds": 18,
      "managerCost": 414000,
      "manager": "Needle Nina",
      "joke": "Alphabetizes by emotional damage.",
      "stat": "merch",
      "scene": 4
    },
    {
      "id": "tour",
      "name": "Tour Van",
      "tag": "music",
      "cost": 400000,
      "revenue": 44000,
      "seconds": 20,
      "managerCost": 1000000,
      "manager": "Exit-Only Eddie",
      "joke": "The itinerary is written on a gas receipt.",
      "stat": "shows",
      "icon": 6,
      "scene": 5
    },
    {
      "id": "pressing",
      "name": "CD Pressing Plant",
      "tag": "music",
      "cost": 1000000,
      "revenue": 105000,
      "seconds": 22,
      "managerCost": 2300000,
      "manager": "Sleeve Louise",
      "joke": "Quality control: shake the box.",
      "stat": "albums",
      "scene": 6
    },
    {
      "id": "label",
      "name": "Independent Label",
      "tag": "music",
      "cost": 2500000,
      "revenue": 230000,
      "seconds": 24,
      "managerCost": 6000000,
      "manager": "Uncle Fine Print",
      "joke": "Our contracts fit on one napkin. Both sides.",
      "stat": "albums",
      "icon": 7,
      "scene": 7
    },
    {
      "id": "venue",
      "name": "All-Ages Venue",
      "tag": "property",
      "cost": 8000000,
      "revenue": 780000,
      "seconds": 26,
      "managerCost": 18400000,
      "manager": "Door-Deal Dee",
      "joke": "The green room is a hallway with a fern.",
      "stat": "shows",
      "scene": 8
    },
    {
      "id": "channel",
      "name": "Channel Nye",
      "tag": "media",
      "cost": 20000000,
      "revenue": 1800000,
      "seconds": 30,
      "managerCost": 45000000,
      "manager": "Static Stacy",
      "joke": "Broadcast standards: a functioning plug.",
      "stat": "videos",
      "icon": 8,
      "scene": 9
    },
    {
      "id": "festival",
      "name": "Independent Festival",
      "tag": "music",
      "cost": 80000000,
      "revenue": 7900000,
      "seconds": 34,
      "managerCost": 184000000,
      "manager": "Wristband Wanda",
      "joke": "Six stages. One extension cord.",
      "stat": "shows",
      "scene": 10
    },
    {
      "id": "games",
      "name": "NYETENDO",
      "tag": "games",
      "cost": 150000000,
      "revenue": 15000000,
      "seconds": 40,
      "managerCost": 350000000,
      "manager": "Patch Tuesday",
      "joke": "It is a feature until somebody records it.",
      "stat": "games",
      "icon": 9,
      "scene": 10
    },
    {
      "id": "arcades",
      "name": "Neighborhood Arcades",
      "tag": "games",
      "cost": 500000000,
      "revenue": 54000000,
      "seconds": 42,
      "managerCost": 1150000000,
      "manager": "Quarter Carter",
      "joke": "Has not seen daylight since the high-score reset.",
      "stat": "games",
      "scene": 11
    },
    {
      "id": "animationstudio",
      "name": "Animation Studio",
      "tag": "media",
      "cost": 1300000000,
      "revenue": 145000000,
      "seconds": 44,
      "managerCost": 2990000000,
      "manager": "Onion-Skin Ollie",
      "joke": "Twenty-four drawings of a terrible decision.",
      "stat": "videos",
      "scene": 11
    },
    {
      "id": "district",
      "name": "Nye Entertainment District",
      "tag": "property",
      "cost": 3500000000,
      "revenue": 420000000,
      "seconds": 46,
      "managerCost": 8050000000,
      "manager": "Block-Party Bev",
      "joke": "Even the zoning meetings have an opening act.",
      "stat": "merch",
      "scene": 11
    },
    {
      "id": "distribution",
      "name": "Nationwide Distribution",
      "tag": "music",
      "cost": 12000000000,
      "revenue": 1500000000,
      "seconds": 48,
      "managerCost": 27600000000,
      "manager": "Manifest Manny",
      "joke": "Your mixtape now has a loading dock.",
      "stat": "albums",
      "scene": 12
    },
    {
      "id": "cinema",
      "name": "Drive-In + Film Studio",
      "tag": "media",
      "cost": 35000000000,
      "revenue": 4700000000,
      "seconds": 50,
      "managerCost": 80500000000,
      "manager": "Second-Take Sal",
      "joke": "The projector has a better agent than us.",
      "stat": "videos",
      "scene": 12
    },
    {
      "id": "worldtour",
      "name": "World Tour Circuit",
      "tag": "music",
      "cost": 100000000000,
      "revenue": 14000000000,
      "seconds": 52,
      "managerCost": 230000000000,
      "manager": "Passport Pat",
      "joke": "The passport has more stickers than the van.",
      "stat": "shows",
      "scene": 13
    },
    {
      "id": "console",
      "name": "NYETENDO Console Works",
      "tag": "games",
      "cost": 300000000000,
      "revenue": 45000000000,
      "seconds": 54,
      "managerCost": 690000000000,
      "manager": "Cartridge Cass",
      "joke": "Blowing into it is still our support policy.",
      "stat": "games",
      "scene": 13
    },
    {
      "id": "satellite",
      "name": "Nye Satellite Uplink",
      "tag": "media",
      "cost": 1000000000000,
      "revenue": 160000000000,
      "seconds": 56,
      "managerCost": 2300000000000,
      "manager": "Dish Donna",
      "joke": "Pirate radio with a much longer antenna.",
      "stat": "streams",
      "scene": 14
    },
    {
      "id": "spaceport",
      "name": "Spaceport Freight",
      "tag": "property",
      "cost": 3000000000000,
      "revenue": 520000000000,
      "seconds": 58,
      "managerCost": 6900000000000,
      "manager": "Countdown Cal",
      "joke": "Please remove your lighter before launch.",
      "stat": "merch",
      "scene": 14
    },
    {
      "id": "lunar",
      "name": "Lunar Recording Studio",
      "tag": "music",
      "cost": 10000000000000,
      "revenue": 1800000000000,
      "seconds": 60,
      "managerCost": 23000000000000,
      "manager": "Low-Gravity Lou",
      "joke": "The bass drops. Everything else floats.",
      "stat": "albums",
      "scene": 15
    },
    {
      "id": "moonwarehouse",
      "name": "Moon Merch Warehouse",
      "tag": "property",
      "cost": 30000000000000,
      "revenue": 5800000000000,
      "seconds": 62,
      "managerCost": 69000000000000,
      "manager": "Crater Kate",
      "joke": "Returns accepted within three lunar cycles.",
      "stat": "merch",
      "scene": 15
    },
    {
      "id": "mars",
      "name": "Mars Tour Dates",
      "tag": "music",
      "cost": 100000000000000,
      "revenue": 21000000000000,
      "seconds": 64,
      "managerCost": 230000000000000,
      "manager": "Red-Dust Russ",
      "joke": "Sold out. Mostly to rocks with excellent taste.",
      "stat": "shows",
      "scene": 16
    },
    {
      "id": "galactic",
      "name": "Interplanetary Distribution",
      "tag": "games",
      "cost": 350000000000000,
      "revenue": 80000000000000,
      "seconds": 66,
      "managerCost": 805000000000000,
      "manager": "Alien A&R",
      "joke": "Finally, a genuinely new demographic.",
      "stat": "games",
      "scene": 17
    }
  ],
  "branches": [
    {
      "id": "music",
      "name": "MUSIC EMPIRE",
      "cost": 1500,
      "growth": 4,
      "description": "+25% music revenue per rank, compounded. Steady, no shutdowns."
    },
    {
      "id": "underground",
      "name": "UNDERGROUND",
      "cost": 2000,
      "growth": 3.5,
      "description": "Pirate radio, warehouse parties and one suspicious plant. Adds risky passive cash. Events can boost or pause it."
    },
    {
      "id": "property",
      "name": "OWN THE BLOCK",
      "cost": 180000,
      "growth": 4,
      "description": "Property revenue +25% per rank. Every rank trims all business prices by 1%, up to 15%."
    },
    {
      "id": "media",
      "name": "PIRATE SIGNAL",
      "cost": 20000000,
      "growth": 4,
      "description": "Media revenue +30% per rank. Your signal boosts music by another 5% per rank."
    },
    {
      "id": "games",
      "name": "CARTRIDGE CULTURE",
      "cost": 150000000,
      "growth": 4,
      "description": "Game revenue +30% per rank. Cabinet royalties keep the lights on."
    },
    {
      "id": "logistics",
      "name": "KEEP IT MOVING",
      "cost": 400000,
      "growth": 4,
      "description": "All businesses run 8% faster per rank, compounded. Shipping is part of the show."
    }
  ],
  "upgrades": [
    {
      "id": "marker",
      "name": "Sharpie Autograph",
      "description": "Double cash from hand-selling CDs.",
      "cost": 40,
      "kind": "click",
      "factor": 2,
      "requires": "cds"
    },
    {
      "id": "sleeves",
      "name": "Sleeves That Close",
      "description": "Burned CD revenue ×2. Luxury is relative.",
      "cost": 220,
      "kind": "business",
      "target": "cds",
      "factor": 2,
      "requires": "cds"
    },
    {
      "id": "bundle",
      "name": "Two Discs, One Speech",
      "description": "Hand-selling income ×5.",
      "cost": 1200,
      "kind": "click",
      "factor": 5,
      "requires": "table"
    },
    {
      "id": "room",
      "name": "Rehearsal Room Lease",
      "description": "All revenue +20%. Business purchase costs −5%. A roof counts as property.",
      "cost": 8000,
      "kind": "global",
      "factor": 1.2,
      "discount": 0.05,
      "requires": "bedroom"
    },
    {
      "id": "press",
      "name": "DIY Pressing Rig",
      "description": "CDs, shirts and merch-table revenue ×3.",
      "cost": 24000,
      "kind": "early",
      "factor": 3,
      "requires": "shows"
    },
    {
      "id": "lawyer",
      "name": "Suspiciously Good Lawyer",
      "description": "Blocks label lawsuit cash losses.",
      "cost": 100000,
      "kind": "defense",
      "requires": "streams"
    },
    {
      "id": "radioantenna",
      "name": "Rooftop Antenna",
      "cost": 120000,
      "kind": "business",
      "target": "radio",
      "factor": 3,
      "requires": "radio",
      "description": "Pirate Radio revenue ×3. The landlord thinks it is modern art."
    },
    {
      "id": "video",
      "name": "One-Take Music Video",
      "description": "Streaming revenue ×3. The mistake is the concept.",
      "cost": 300000,
      "kind": "business",
      "target": "streams",
      "factor": 3,
      "requires": "streams"
    },
    {
      "id": "shoplease",
      "name": "The Whole Storefront",
      "cost": 900000,
      "kind": "business",
      "target": "shop",
      "factor": 3,
      "requires": "shop",
      "description": "Record shop revenue ×3. Finally room for the bargain bins."
    },
    {
      "id": "warehouse",
      "name": "Warehouse Keys",
      "description": "All revenue ×2. Business purchase costs another −5%.",
      "cost": 2000000,
      "kind": "global",
      "factor": 2,
      "discount": 0.05,
      "requires": "tour"
    },
    {
      "id": "diesel",
      "name": "Van That Starts",
      "cost": 3000000,
      "kind": "business",
      "target": "tour",
      "factor": 4,
      "requires": "tour",
      "description": "Tour Van revenue ×4. The driver can stop pushing."
    },
    {
      "id": "venuepa",
      "name": "House PA System",
      "cost": 24000000,
      "kind": "business",
      "target": "venue",
      "factor": 3,
      "requires": "venue",
      "description": "Venue revenue ×3. The vocals are now technically audible."
    },
    {
      "id": "comic",
      "name": "NYESTALGIC Comic Imprint",
      "description": "Channel Nye and NYETENDO revenue ×3. The margins have lore.",
      "cost": 35000000,
      "kind": "media",
      "factor": 3,
      "requires": "label"
    },
    {
      "id": "festivaltape",
      "name": "Festival Live Tapes",
      "cost": 240000000,
      "kind": "business",
      "target": "festival",
      "factor": 4,
      "requires": "festival",
      "description": "Festival revenue ×4. Sell the memory twice."
    },
    {
      "id": "animation",
      "name": "Animation Night Shift",
      "description": "All revenue ×3. Every frame smells like coffee.",
      "cost": 600000000,
      "kind": "global",
      "factor": 3,
      "requires": "channel"
    },
    {
      "id": "animatic",
      "name": "The In-Between Department",
      "cost": 4000000000,
      "kind": "business",
      "target": "animationstudio",
      "factor": 4,
      "requires": "animationstudio",
      "description": "Animation Studio revenue ×4. Somebody finally drew the other leg."
    },
    {
      "id": "blockpower",
      "name": "Neighborhood Power Grid",
      "cost": 12000000000,
      "kind": "global",
      "target": null,
      "factor": 2,
      "requires": "district",
      "description": "All revenue ×2. No more running the festival off a kitchen socket."
    },
    {
      "id": "tourrights",
      "name": "Worldwide Live Rights",
      "cost": 350000000000,
      "kind": "business",
      "target": "worldtour",
      "factor": 4,
      "requires": "worldtour",
      "description": "World Tour revenue ×4. Keep the masters. Keep the receipts."
    },
    {
      "id": "orbital",
      "name": "Lunar Distribution Rights",
      "description": "All revenue ×10. Same scratched CDs. Less gravity.",
      "cost": 5000000000000,
      "kind": "global",
      "factor": 10,
      "requires": "spaceport"
    },
    {
      "id": "rocketfuel",
      "name": "Secondhand Rocket Fuel",
      "cost": 9000000000000,
      "kind": "business",
      "target": "spaceport",
      "factor": 4,
      "requires": "spaceport",
      "description": "Spaceport revenue ×4. It passed somebody’s inspection."
    },
    {
      "id": "moonbooth",
      "name": "Air-Tight Vocal Booth",
      "cost": 35000000000000,
      "kind": "business",
      "target": "lunar",
      "factor": 4,
      "requires": "lunar",
      "description": "Lunar Studio revenue ×4. In space, everyone can hear the ad-libs."
    }
  ],
  "stocks": [
    {
      "id": "nyfm",
      "name": "Fake FM",
      "ticker": "NYFM",
      "base": 25,
      "vol": 0.13,
      "blurb": "Plays the same three songs. Calls it discovery."
    },
    {
      "id": "ncrt",
      "name": "Nye Carton",
      "ticker": "NCRT",
      "base": 80,
      "vol": 0.2,
      "blurb": "Premium cardboard. The economy is mostly boxes."
    },
    {
      "id": "moon",
      "name": "Moon Merch",
      "ticker": "MOON",
      "base": 150,
      "vol": 0.27,
      "blurb": "Shipping estimates measured in orbital periods."
    }
  ],
  "events": [
    {
      "id": "viral",
      "title": "YOUR SONG BECAME A MEME",
      "copy": "Nobody knows the second verse. Streaming ×5 for 30 seconds.",
      "target": "streams",
      "factor": 5,
      "duration": 30
    },
    {
      "id": "show",
      "title": "WAREHOUSE SHOW",
      "copy": "The secret address was only slightly wrong. Underground income ×4 for 25 seconds.",
      "target": "underground",
      "factor": 4,
      "duration": 25
    },
    {
      "id": "algorithm",
      "title": "ALGORITHM HATES YOU",
      "copy": "It wants a dance tutorial. Streaming income ×0.4 for 20 seconds.",
      "target": "streams",
      "factor": 0.4,
      "duration": 20
    },
    {
      "id": "van",
      "title": "THE VAN HAS OPINIONS",
      "copy": "The engine is taking a creative break. Tour income pauses for 18 seconds.",
      "target": "tour",
      "factor": 0,
      "duration": 18
    },
    {
      "id": "cease",
      "title": "CEASE AND PLEASE STOP",
      "copy": "Underground operations shut down for 20 seconds. The paperwork has glitter on it.",
      "target": "underground",
      "factor": 0,
      "duration": 20
    },
    {
      "id": "lawsuit",
      "title": "LABEL LAWSUIT",
      "copy": "Somebody trademarked breathing near a microphone. Lose 5% cash, capped at two minutes of income. Lawyer blocks it.",
      "target": "cash",
      "duration": 12
    },
    {
      "id": "blackie",
      "title": "BLACKIE MIXED THE MASTER",
      "copy": "A paw landed on the right fader. All income ×2 for 20 seconds.",
      "target": "all",
      "factor": 2,
      "duration": 20
    },
    {
      "id": "investor",
      "title": "MYSTERY INVESTOR",
      "copy": "A suspicious envelope: 20 seconds of automated income, paid immediately.",
      "target": "gift",
      "duration": 12
    }
  ],
  "eras": [
    {
      "at": 0,
      "name": "MATT’S TRUNK",
      "caption": "One crate. No business plan. Excellent handwriting.",
      "sheet": "old",
      "frame": 0
    },
    {
      "at": 90,
      "name": "FLEA MARKET SUNDAYS",
      "caption": "First a parking space. Then a regular crowd.",
      "sheet": "streets",
      "frame": 0
    },
    {
      "at": 3200,
      "name": "BEDROOM BUSINESS",
      "caption": "The booth is a closet. The neighbors know every verse.",
      "sheet": "old",
      "frame": 1
    },
    {
      "at": 15000,
      "name": "BASEMENT CIRCUIT",
      "caption": "Flyers, loose cables, and a room that actually listens.",
      "sheet": "streets",
      "frame": 1
    },
    {
      "at": 180000,
      "name": "THE CORNER RECORD SHOP",
      "caption": "Your own keys. Your own listening station.",
      "sheet": "streets",
      "frame": 2
    },
    {
      "at": 400000,
      "name": "THE LONG WAY HOME",
      "caption": "Diners, motel floors, and the next city on the route.",
      "sheet": "streets",
      "frame": 3
    },
    {
      "at": 1000000,
      "name": "PRESSING AFTER MIDNIGHT",
      "caption": "From hand-burned discs to pallets of your own records.",
      "sheet": "streets",
      "frame": 4
    },
    {
      "at": 2500000,
      "name": "STUDIO ROW",
      "caption": "Bring the rehearsal rooms, engineers, and label onto one block.",
      "sheet": "streets",
      "frame": 5
    },
    {
      "at": 8000000,
      "name": "THE VENUE STRIP",
      "caption": "Doors are open. Every room has its own scene.",
      "sheet": "empire",
      "frame": 0
    },
    {
      "at": 20000000,
      "name": "NYESTALGIC HQ",
      "caption": "A broadcast booth upstairs. A warehouse full of records below.",
      "sheet": "old",
      "frame": 3
    },
    {
      "at": 80000000,
      "name": "FESTIVAL GROUNDS",
      "caption": "A whole field of independent noise. Still one missing extension cord.",
      "sheet": "empire",
      "frame": 1
    },
    {
      "at": 500000000,
      "name": "THE ENTERTAINMENT DISTRICT",
      "caption": "Arcades, studios, cinema: build a neighborhood people come back to.",
      "sheet": "empire",
      "frame": 2
    },
    {
      "at": 12000000000,
      "name": "COAST TO COAST",
      "caption": "Your own freight network. Same records, many more loading docks.",
      "sheet": "empire",
      "frame": 3
    },
    {
      "at": 100000000000,
      "name": "THE WORLD TOUR",
      "caption": "A passport full of venues. Keep the local roots.",
      "sheet": "empire",
      "frame": 4
    },
    {
      "at": 1000000000000,
      "name": "ORBITAL PIRATE RADIO",
      "caption": "The signal reaches orbit before the merch does.",
      "sheet": "empire",
      "frame": 5
    },
    {
      "at": 10000000000000,
      "name": "MOON MERCH",
      "caption": "A real lunar studio, not just a sticker on the van.",
      "sheet": "old",
      "frame": 5
    },
    {
      "at": 100000000000000,
      "name": "MARS AFTER HOURS",
      "caption": "The next gig is on the next planet.",
      "sheet": "old",
      "frame": 5
    },
    {
      "at": 350000000000000,
      "name": "INTERPLANETARY INDIE",
      "caption": "Universal distribution. Absolutely no corporate supervision.",
      "sheet": "old",
      "frame": 5
    }
  ],
  "rewards": [
    {
      "id": "listen",
      "at": 100,
      "title": "The first record",
      "kind": "link",
      "label": "PLAY I’LL BE FINE",
      "url": "/#record-ill-be-fine",
      "copy": "A real record behind the fictional hustle."
    },
    {
      "id": "vault",
      "at": 10000,
      "title": "After-hours tape",
      "kind": "lore",
      "copy": "RECEIPT #001: The first corporate headquarters was a trunk. The trunk had better acoustics."
    },
    {
      "id": "arcade",
      "at": 100000,
      "title": "Staff arcade break",
      "kind": "link",
      "label": "PLAY NYE CRUSH",
      "url": "/collections/nyestalgic-games?view=nyecrush",
      "copy": "Nobody clocked out. Somehow productivity improved."
    },
    {
      "id": "toxic",
      "at": 1000000,
      "title": "Toxic terminal",
      "kind": "theme",
      "copy": "Unlock the toxic-green desk skin. Same terrible accountant."
    },
    {
      "id": "watch",
      "at": 10000000,
      "title": "Channel unlocked",
      "kind": "link",
      "label": "WATCH MATT NYE",
      "url": "/#watch",
      "copy": "Actual music videos. Fictional operating budget."
    },
    {
      "id": "discount",
      "at": 100000000,
      "title": "Backstage perks",
      "kind": "placeholder",
      "copy": "This drawer is still being stocked. Nothing to redeem yet—real store offers will appear here when available."
    }
  ],
  "blackieCost": 999999999,
  "achievements": [
    {
      "id": "first",
      "title": "ONE DOLLAR AT A TIME",
      "copy": "Hand-sell your first CD.",
      "metric": "clicks",
      "at": 1
    },
    {
      "id": "trunk",
      "title": "TRUNK ACCOUNTING",
      "copy": "Hand-sell 100 CDs.",
      "metric": "clicks",
      "at": 100
    },
    {
      "id": "manager",
      "title": "SOMEONE ELSE’S PROBLEM",
      "copy": "Hire your first manager.",
      "metric": "managers",
      "at": 1
    },
    {
      "id": "units",
      "title": "IT’S MOSTLY CARDBOARD",
      "copy": "Own 100 businesses.",
      "metric": "owned",
      "at": 100
    },
    {
      "id": "million",
      "title": "SELL OUT",
      "copy": "Produce your first million. Ironically, obviously.",
      "metric": "lifetime",
      "at": 1000000
    },
    {
      "id": "indie",
      "title": "STILL INDEPENDENT",
      "copy": "Produce $10M. No corporate buyout button required.",
      "metric": "lifetime",
      "at": 10000000
    },
    {
      "id": "shift",
      "title": "NO SLEEP",
      "copy": "Spend an hour running the empire.",
      "metric": "played",
      "at": 3600
    },
    {
      "id": "stocks",
      "title": "CANDLESTICK VANDAL",
      "copy": "Trade 100 fictional shares.",
      "metric": "shares",
      "at": 100
    },
    {
      "id": "branches",
      "title": "QUESTIONABLE PORTFOLIO",
      "copy": "Invest in two different departments.",
      "metric": "paths",
      "at": 2
    },
    {
      "id": "timeline",
      "title": "BAD TIMELINE",
      "copy": "Rebuild your empire with Street Cred.",
      "metric": "prestiges",
      "at": 1
    },
    {
      "id": "cat",
      "title": "CAT ACCOUNTANT",
      "copy": "Hire Mr. Blackie. He did not interview.",
      "metric": "catHired",
      "at": 1
    },
    {
      "id": "moon",
      "title": "SPACE IS ALSO RENTED",
      "copy": "Produce $10T in one timeline and reach Moon Merch.",
      "metric": "run",
      "at": 10000000000000
    },
    {
      "id": "citybuilder",
      "title": "A BLOCK OF YOUR OWN",
      "copy": "Produce $3.5B this timeline.",
      "metric": "run",
      "at": 3500000000
    },
    {
      "id": "delivery",
      "title": "YES, WE ACTUALLY DELIVER",
      "copy": "Finish ten independent contracts.",
      "metric": "contracts",
      "at": 10
    },
    {
      "id": "orbit",
      "title": "PIRATE RADIO HAS ESCAPED",
      "copy": "Produce $1T this timeline.",
      "metric": "run",
      "at": 1000000000000
    }
  ],
  "legacyBusinessIds": [
    "cds",
    "shirts",
    "table",
    "bedroom",
    "shows",
    "streams",
    "tour",
    "label",
    "channel",
    "games"
  ],
  "focuses": [
    {
      "id": "balanced",
      "name": "DIY / ALL HANDS",
      "copy": "No trade-offs. Every department earns its normal rate.",
      "boost": [],
      "drag": [],
      "factor": 1,
      "penalty": 1
    },
    {
      "id": "records",
      "name": "RECORDS FIRST",
      "copy": "Music ×1.6; media and games ×0.8. Build the catalog.",
      "boost": [
        "music"
      ],
      "drag": [
        "media",
        "games"
      ],
      "factor": 1.6,
      "penalty": 0.8
    },
    {
      "id": "street",
      "name": "OWN THE NIGHT",
      "copy": "Underground + property ×1.6; music ×0.85. Fill the rooms.",
      "boost": [
        "underground",
        "property"
      ],
      "drag": [
        "music"
      ],
      "factor": 1.6,
      "penalty": 0.85
    },
    {
      "id": "broadcast",
      "name": "SCREEN TAKEOVER",
      "copy": "Media + games ×1.6; property and underground ×0.8.",
      "boost": [
        "media",
        "games"
      ],
      "drag": [
        "property",
        "underground"
      ],
      "factor": 1.6,
      "penalty": 0.8
    }
  ]
};C.managers=[{"id": "nina", "name": "Needle Nina", "role": "THE TASTEMAKER", "cost": 250, "at": 90, "revenue": 1.15, "speed": 1, "fans": 1.6, "copy": "Knows your next favorite record. Judges your last one.", "perk": "+15% batch cash \u00b7 +60% fans", "portrait": 0}, {"id": "louise", "name": "Sleeve Louise", "role": "THE FOREMAN", "cost": 1500, "at": 1500, "revenue": 0.9, "speed": 1.4, "fans": 1, "copy": "Runs the plant on coffee and barely contained fury.", "perk": "40% faster cycles \u00b7 10% less cash per batch", "portrait": 1}, {"id": "penny", "name": "Penny Proof", "role": "THE FIXER OF RECEIPTS", "cost": 6500, "at": 10000, "revenue": 1.05, "speed": 1, "fans": 1, "copy": "The only person here who keeps the receipt.", "perk": "+5% batch cash \u00b7 heat cools 3 points/min faster", "portrait": 2}, {"id": "cal", "name": "Cassette Cal", "role": "THE TAPE WIZARD", "cost": 25000, "at": 35000, "revenue": 1.1, "speed": 1.2, "fans": 1.2, "copy": "Says the hiss is part of the song. He is right.", "perk": "+10% batch cash \u00b7 20% faster \u00b7 +20% fans", "portrait": 3}, {"id": "vic", "name": "Velvet Vic", "role": "THE INDUSTRY GUY", "cost": 75000, "at": 75000, "revenue": 1.6, "speed": 1, "fans": 0.5, "copy": "Calls everybody family. Has never helped anyone move.", "perk": "+60% batch cash \u00b7 half the fans \u00b7 +3.6 heat/min", "portrait": 4}, {"id": "auntie", "name": "Auntie Amp", "role": "THE NEIGHBORHOOD", "cost": 175000, "at": 180000, "revenue": 1.05, "speed": 1, "fans": 2.5, "copy": "Fed the whole block. Turned your demo all the way up.", "perk": "+5% batch cash \u00b7 2.5\u00d7 fans \u00b7 +1.2 trust/min", "portrait": 5}];C.decisions=[{"id": "airplay", "title": "THE DJ WANTS A WORD.", "at": 90, "fans": 0, "copy": "The local station has one late-night slot. How are you getting on air?", "options": [{"id": "session", "title": "Play a free live session", "cost": 40, "cash": 0, "fans": 12, "trust": 8, "heat": 0, "network": 0, "scene": "community", "copy": "Bring the records. Stay to help pack up."}, {"id": "envelope", "title": "Slide over an envelope", "cost": 20, "cash": 120, "fans": 2, "trust": -8, "heat": 14, "network": 0, "scene": "deal", "copy": "A sudden, entirely coincidental spike in airplay."}]}, {"id": "pressing", "title": "WHO OWNS THE PRESS?", "at": 1500, "fans": 20, "copy": "A local pressing shop needs help. The artists are waiting on their copies.", "options": [{"id": "cooperative", "title": "Build an artist co-op", "cost": 450, "cash": 0, "fans": 80, "trust": 12, "heat": 0, "network": 1, "scene": "community", "copy": "Share the plant and pay the people running it."}, {"id": "bootleg", "title": "Run an unauthorized batch", "cost": 150, "cash": 2400, "fans": 5, "trust": -15, "heat": 25, "network": 0, "scene": "deal", "copy": "Fast money. Somebody else\u2019s work. They will notice."}]}, {"id": "rival", "title": "THE RIVAL DOWN THE BLOCK.", "at": 15000, "fans": 75, "copy": "A fictional rival label is poaching your venue slots. Your contact offers two very different introductions.", "options": [{"id": "bill", "title": "Offer a shared headline show", "cost": 5000, "cash": 0, "fans": 240, "trust": 12, "heat": 0, "network": 1, "scene": "community", "copy": "Give both crowds a reason to turn up."}, {"id": "hit", "title": "Send the mob contact", "cost": 3000, "cash": 20000, "fans": 0, "trust": -28, "heat": 50, "network": 0, "scene": "hit", "copy": "A violent street ambush. Empty venue slots, frightened fans and serious heat."}]}, {"id": "masters", "title": "THE MASTERS ARE ON THE TABLE.", "at": 75000, "fans": 200, "copy": "The artists want ownership. A buyer wants the entire catalog.", "options": [{"id": "rights", "title": "Keep the masters with the artists", "cost": 18000, "cash": 0, "fans": 700, "trust": 12, "heat": 0, "network": 1, "scene": "community", "copy": "Build a catalog people actually want to stand behind."}, {"id": "sellout", "title": "Sign the catalog away", "cost": 4000, "cash": 65000, "fans": -100, "trust": -22, "heat": 15, "network": 0, "scene": "deal", "copy": "The cheque is huge. The small print is bigger."}]}];if(typeof module!=="undefined"&&module.exports)module.exports=C;else g.NyeconomyConfig=C;})(typeof window==="undefined"?globalThis:window);